import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0674 16.0184H28",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3049 12.3262L28 16.0185L24.3049 19.7108",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6745 24.3077C23.0155 26.0356 20.8771 27.228 18.5344 27.7316C16.1916 28.2352 13.7517 28.0269 11.5284 27.1335C9.30514 26.2401 7.40017 24.7025 6.05854 22.7184C4.71692 20.7343 4 18.3946 4 16C4 13.6054 4.71692 11.2657 6.05854 9.28157C7.40017 7.2975 9.30514 5.75987 11.5284 4.86648C13.7517 3.97309 16.1916 3.76479 18.5344 4.26837C20.8771 4.77196 23.0155 5.9644 24.6745 7.69231",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLogout);
export default ForwardRef;
